const PER_PAGE = 20;

function initPublicationsArchive(container) {
    const list = container.querySelector('.publications-list');
    if (!list) return;

    const items = Array.from(list.querySelectorAll('.publication-item'));
    const filterGroups = Array.from(document.querySelectorAll('[data-filter-group]'));
    const emptyMessage = container.querySelector('[data-publications-empty]');
    const pagination = container.querySelector('[data-pagination]');
    const pagesContainer = pagination?.querySelector('[data-pagination-pages]');
    const prevButton = pagination?.querySelector('[data-pagination-prev]');
    const nextButton = pagination?.querySelector('[data-pagination-next]');

    // Each group holds a *set* of selected values — filters are non-exclusive
    // within a group (OR'd together), while different groups are AND'd. An
    // empty set means "no filter" / "All" for that group.
    const groupsByName = {};
    const activeFilters = {};
    filterGroups.forEach((group) => {
        groupsByName[group.dataset.filterGroup] = group;
        activeFilters[group.dataset.filterGroup] = new Set();
    });

    let currentPage = 1;
    let matches = items;

    function itemMatchesGroup(item, group, selectedValues) {
        if (selectedValues.size === 0) return true;
        if (group === 'year') return selectedValues.has(item.dataset.year);

        const key = `${group}s`; // types, themes, languages
        const ids = (item.dataset[key] || '').split(',').filter(Boolean);
        return ids.some((id) => selectedValues.has(id));
    }

    function applyFilters() {
        matches = items.filter((item) =>
            Object.entries(activeFilters).every(([group, values]) => itemMatchesGroup(item, group, values))
        );
        currentPage = 1;
        render();
    }

    function render() {
        const totalPages = Math.max(1, Math.ceil(matches.length / PER_PAGE));
        currentPage = Math.min(currentPage, totalPages);

        const start = (currentPage - 1) * PER_PAGE;
        const pageItems = matches.slice(start, start + PER_PAGE);

        items.forEach((item) => item.classList.add('hidden'));
        pageItems.forEach((item) => item.classList.remove('hidden'));

        emptyMessage?.classList.toggle('hidden', matches.length > 0);
        renderPagination(totalPages);
    }

    function renderPagination(totalPages) {
        if (!pagination) return;

        pagination.classList.toggle('hidden', matches.length === 0 || totalPages <= 1);

        if (prevButton) prevButton.disabled = currentPage <= 1;
        if (nextButton) nextButton.disabled = currentPage >= totalPages;

        if (!pagesContainer) return;
        pagesContainer.innerHTML = '';
        for (let page = 1; page <= totalPages; page++) {
            const button = document.createElement('button');
            button.type = 'button';
            button.textContent = String(page);
            button.dataset.page = String(page);
            button.className =
                'pagination-page cursor-pointer border-1 border-black rounded-full aspect-square px-2 py-0 text-[13px] font-ibm-plex-mono' +
                (page === currentPage ? ' is-active' : '');
            pagesContainer.appendChild(button);
        }
    }

    function updateChipStates(group, selectedValues) {
        group.querySelectorAll('.filter-chip').forEach((el) => {
            const value = el.dataset.filterValue;
            const isActive = value === 'all' ? selectedValues.size === 0 : selectedValues.has(value);
            el.classList.toggle('is-active', isActive);
        });
    }

    // Shared by sidebar filter chips and the clickable tags on each
    // publication card. Clicking "All" clears the group; clicking a value
    // toggles it in/out of the group's selection.
    function toggleFilter(groupName, value) {
        const group = groupsByName[groupName];
        const selectedValues = activeFilters[groupName];
        if (!group || !selectedValues) return;

        if (value === 'all') {
            selectedValues.clear();
        } else if (selectedValues.has(value)) {
            selectedValues.delete(value);
        } else {
            selectedValues.add(value);
        }

        updateChipStates(group, selectedValues);
        applyFilters();
    }

    filterGroups.forEach((group) => {
        group.addEventListener('click', (event) => {
            const chip = event.target.closest('li[data-filter-value]');
            if (!chip || !group.contains(chip)) return;
            toggleFilter(group.dataset.filterGroup, chip.dataset.filterValue);
        });
    });

    list.addEventListener('click', (event) => {
        const tag = event.target.closest('[data-tag-group]');
        if (!tag) return;
        toggleFilter(tag.dataset.tagGroup, tag.dataset.tagValue);
    });

    prevButton?.addEventListener('click', () => {
        if (currentPage > 1) {
            currentPage -= 1;
            render();
        }
    });

    nextButton?.addEventListener('click', () => {
        currentPage += 1;
        render();
    });

    pagesContainer?.addEventListener('click', (event) => {
        const button = event.target.closest('[data-page]');
        if (!button) return;
        currentPage = Number(button.dataset.page);
        render();
    });

    // Pre-select a filter from the URL (e.g. a publication's tag linking back
    // here with ?type=123) instead of defaulting every group to "All".
    const params = new URLSearchParams(window.location.search);
    filterGroups.forEach((group) => {
        const groupName = group.dataset.filterGroup;
        const value = params.get(groupName);
        if (!value) return;

        activeFilters[groupName].add(value);
        updateChipStates(group, activeFilters[groupName]);
    });

    applyFilters();
}

function initFilterToggles() {
    document.querySelectorAll('[data-filter-toggle]').forEach((title) => {
        const termsList = title.nextElementSibling;
        if (!termsList) return;

        // .filter-terms is hidden by default on mobile and shown on desktop
        // (see styles.css); .is-toggled inverts whichever is the current
        // breakpoint's default, so read the real computed state rather than
        // assuming what the class list implies.
        const syncCollapsedState = () => {
            const isCollapsed = getComputedStyle(termsList).display === 'none';
            title.classList.toggle('is-collapsed', isCollapsed);
        };

        syncCollapsedState();

        title.addEventListener('click', () => {
            termsList.classList.toggle('is-toggled');
            syncCollapsedState();
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('[data-publications-container]');
    if (container) initPublicationsArchive(container);
    initFilterToggles();
});
